/**
 * Vue next-tick
 * https://v3.cn.vuejs.org/api/global-api.html#nexttick
 */
var resolvedPromise = Promise.resolve();
var currentFlushPromise = null;
export function nextTick(fn) {
    var p = currentFlushPromise || resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
export function timeout(time) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, time);
    });
}
